import { COMMON } from '@constants';
import { Button, HStack } from '@lib/uikit';
import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import {
    useProgressContext,
    useProgressDispatchContext,
} from '../../contexts/ProgressContext';
import { useFlow } from '@lib/pimster-flow/contexts/FlowContext';
import Icon from '@components/utils/icons/icon';

export const NavigationButtons: FC = () => {
    const { t } = useTranslation(COMMON);
    const { currentPageIndex, numberOfPages } = useProgressContext();
    const dispatch = useProgressDispatchContext();
    const { onPrevious, onNext } = useFlow();

    const handleNavigationPrevious = () => {
        if (currentPageIndex === 0) {
            return onPrevious();
        }

        dispatch({ type: 'PREVIOUS_PAGE' });
    };

    const handleNavigationNext = () => {
        if (currentPageIndex === numberOfPages - 1) {
            return onNext();
        }

        dispatch({ type: 'NEXT_PAGE' });
    };

    return (
        <HStack spacing='sm'>
            <Button
                buttonSize='small'
                colorScheme='white'
                onClick={handleNavigationPrevious}
            >
                <Icon name='chevron_left' size='medium' />
            </Button>
            <Button
                isFullWidth
                colorScheme='white'
                onClick={handleNavigationNext}
            >
                {t('continue')}
            </Button>
        </HStack>
    );
};
